module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_05_beach-photo-b8231b57ca6054cf3fa9d610abfc104e.jpg";